// @flow
import type { RioResponse, Subscription } from 'digicel-kaizen-library';

export type RioAction =
  | {|
      type: 'FETCH_RIO_REQUEST',
      payload: {|
        subscription: ?Subscription,
      |},
    |}
  | {|
      type: 'FETCH_RIO_SUCCESS',
      response: RioResponse,
    |}
  | {|
      type: 'FETCH_RIO_FAILURE',
    |};

export const fetchRioRequest = (subscription: ?Subscription): RioAction => ({
  type: 'FETCH_RIO_REQUEST',
  payload: {
    subscription,
  },
});

export const fetchRioSuccess = (response: RioResponse): RioAction => ({
  type: 'FETCH_RIO_SUCCESS',
  response,
});

export const fetchRioFailure = (): RioAction => ({
  type: 'FETCH_RIO_FAILURE',
});
